import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { AppStateService, MEMBER_STATUS_ROLES } from '../services/app-state.service';

export const msrInteressentNEWGuard: CanActivateFn = () => {
  const appState = inject(AppStateService);
  const router = inject(Router);

  const status = appState.profile()?.memberStatus;
  const idx = MEMBER_STATUS_ROLES.indexOf(status ?? '');

  if (idx == MEMBER_STATUS_ROLES.indexOf('InteressentNEW')) {
    return true;
  }

  return router.createUrlTree(['/init']);
};
